import { useContext, useEffect, useState } from 'react';

import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';

import { ClassifierContext } from '../../context/classifier/ClassifierContext';

import Message from '../../components/ui/Message';



export const ClassifierPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const [isFormValid, setIsFormValid] = useState(false);

    const {
        addClassifier,
        updateClassifier
    } = useContext(ClassifierContext);

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');


    let classifier;


    if (state) {

        classifier = state.classifier;

    } else {

        classifier = {

            classifierId: -1,
            code: '',
            name: '',
            category: 'DEVICE_MGT',
            description: ''

        }

    }



    const { formState, onInputChange } = useForm(classifier);


    const {
        classifierId,
        code,
        name,
        category,
        description
    } = formState;



    useEffect(() => {

        const formValid =
            code.length > 0 &&
            name.length > 0 &&
            category.length > 0;

        setIsFormValid(formValid);

    }, [code, name, category]);



    const handleSave = async () => {

        let resp = "";


        if (classifierId > 0) {

            resp = await updateClassifier(formState);

        }
        else {
            formState.classifierId = undefined;
            resp = await addClassifier(formState);

        }


        if (resp === "success") {

            setSuccessMessage(

                classifierId > 0
                    ?
                    "Clasificador actualizado correctamente"
                    :
                    "Clasificador creado correctamente"

            );

        }
        else {

            setErrorMessage(resp);

        }

    }



    const removeError = () => {

        setErrorMessage('');

    }



    const removeSuccessMessage = () => {

        setSuccessMessage('');

        navigate(-1);

    }



    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>


                <h3>

                    {
                        classifierId > 0
                            ?
                            'Actualizar clasificador'
                            :
                            'Crear clasificador'
                    }

                </h3>


                <hr />



                <form className="row g-3">


                    {/* Código */}

                    <div className="mb-3">

                        <label className="form-label">
                            Código
                        </label>

                        <input

                            type="text"

                            disabled={classifierId > 0}

                            className={`form-control ${code ? 'is-valid' : 'is-invalid'}`}

                            placeholder="Código"

                            name="code"

                            value={code}

                            onChange={onInputChange}

                        />

                    </div>

                    {/* Nombre */}

                    <div className="mb-3">

                        <label className="form-label">
                            Nombre
                        </label>

                        <input

                            type="text"

                            className={`form-control ${name ? 'is-valid' : 'is-invalid'}`}

                            placeholder="Nombre clasificador"

                            name="name"

                            value={name}

                            onChange={onInputChange}

                        />

                    </div>









                    {/* Categoría */}

                    <div className="mb-3">

                        <label className="form-label">
                            Categoría
                        </label>

                        <input

                            type="text"

                            className={`form-control ${category ? 'is-valid' : 'is-invalid'}`}

                            placeholder="Categoría"

                            name="category"

                            value={category}

                            onChange={onInputChange}

                        />

                    </div>




                    {/* Descripción */}

                    <div className="mb-3">

                        <label className="form-label">
                            Descripción
                        </label>

                        <textarea

                            className="form-control"

                            rows={3}

                            placeholder="Descripción del clasificador"

                            name="description"

                            value={description}

                            onChange={onInputChange}

                        />

                    </div>




                    {/* Botones */}

                    <div className='container d-flex align-items-center justify-content-center mt-5'>


                        <button

                            type="button"

                            onClick={() => navigate(-1)}

                            className="btn btn-outline-secondary"

                        >

                            Atrás

                        </button>



                        <button

                            type="button"

                            onClick={handleSave}

                            className="btn btn-primary ms-5"

                            disabled={!isFormValid}

                        >

                            Guardar

                        </button>



                    </div>



                </form>


                <div style={{ height: '100px' }}></div>

            </div>




            {
                errorMessage.length > 0 &&

                <Message
                    type='error'
                    message={errorMessage}
                    closeDialog={removeError}
                    handleOk={removeError}
                    backgroundColor='rgba(0,0,0,0.4)'
                />
            }



            {
                successMessage.length > 0 &&

                <Message
                    type='success'
                    title='Exitoso'
                    message={successMessage}
                    closeDialog={removeSuccessMessage}
                    handleOk={removeSuccessMessage}
                    backgroundColor='rgba(0,0,0,0.4)'
                />
            }



        </div>

    )

}



const styles = {

    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }

};